module.exports = __webpack_public_path__ + "images/program/torch.0db75207.svg";